(() => {
  let library, ready = false, loading = false;
  const labels = new WeakMap();
  function notice(button, text, error = false) {
    let status = document.getElementById('catalogue-download-status');
    if (!status) {
      status = document.createElement('p');
      status.id = 'catalogue-download-status';
      status.className = 'catalogue-download-status';
      button.after(status);
    }
    status.setAttribute('role', error ? 'alert' : 'status');
    status.setAttribute('aria-live', 'polite');
    status.textContent = text;
  }
  function load() {
    if (library) return library;
    library = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = '/apps/espace-camilia/assets/catalogue-download.js';
      script.dataset.prefix = '/apps/espace-camilia';
      script.onload = () => { ready = true; resolve(); };
      script.onerror = () => { library = null; script.remove(); reject(new Error('load')); };
      document.head.append(script);
    });
    return library;
  }
  function followPreparation(button) {
    setTimeout(() => {
      if (button.getAttribute('aria-busy') !== 'true') return;
      notice(button, 'Le catalogue est toujours en préparation. Le téléchargement sera lancé une fois le PDF prêt.');
    }, 8000);
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-catalogue-download]');
    if (!button) return;
    if (!labels.has(button)) labels.set(button, button.textContent);
    if (ready) {
      if (button.getAttribute('aria-busy') !== 'true') button.textContent = labels.get(button);
      followPreparation(button);
      return;
    }
    event.preventDefault();
    if (loading) return;
    loading = true;
    const label = labels.get(button);
    button.textContent = 'Chargement du catalogue…';
    button.setAttribute('aria-busy', 'true');
    notice(button, 'Le PDF se téléchargera automatiquement une fois prêt.');
    let timeout;
    try {
      await Promise.race([
        load(),
        new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('timeout')), 30000); })
      ]);
      button.textContent = label;
      button.removeAttribute('aria-busy');
      button.click();
    } catch {
      button.textContent = 'Réessayer le catalogue PDF';
      button.removeAttribute('aria-busy');
      notice(button, 'Le chargement du catalogue n’a pas abouti. Réessayez dans un instant.', true);
    } finally {
      clearTimeout(timeout);
      loading = false;
    }
  });
})();
